var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2422 4.00029C17.2422 4.00029 12.1622 3.90696 8.42891 7.05363C8.42891 7.05363 2.54891 12.187 5.17557 18.8136C5.17557 18.8136 6.53557 21.6803 9.88224 21.6803C9.88224 21.6803 11.4022 21.747 11.4022 23.3736C11.4022 23.3736 12.0289 28.987 17.3622 28.707C17.3622 28.707 27.3356 28.267 29.4156 16.4136C29.8333 15.3333 30.3489 3.93363 17.2422 4.00029ZM10.0156 17.707C8.54891 17.707 7.34891 16.507 7.34891 15.0403C7.34891 13.5736 8.54891 12.3736 10.0156 12.3736C11.4822 12.3736 12.6822 13.5736 12.6822 15.0403C12.6822 16.507 11.4822 17.707 10.0156 17.707Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8031 7.53369C18.8031 8.41735 18.0868 9.13369 17.2031 9.13369C16.3195 9.13369 15.6031 8.41735 15.6031 7.53369C15.6031 6.65004 16.3195 5.93369 17.2031 5.93369C18.0868 5.93369 18.8031 6.65004 18.8031 7.53369Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.536 10.0537C25.536 10.9374 24.8197 11.6537 23.936 11.6537C23.0524 11.6537 22.336 10.9374 22.336 10.0537C22.336 9.17006 23.0524 8.45371 23.936 8.45371C24.8197 8.45371 25.536 9.17006 25.536 10.0537Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.536 16.5601C27.536 17.4437 26.8197 18.1601 25.936 18.1601C25.0524 18.1601 24.336 17.4437 24.336 16.5601C24.336 15.6764 25.0524 14.9601 25.936 14.9601C26.8197 14.9601 27.536 15.6764 27.536 16.5601Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0023 23.0806C25.0023 23.9642 24.286 24.6806 23.4023 24.6806C22.5187 24.6806 21.8023 23.9642 21.8023 23.0806C21.8023 22.1969 22.5187 21.4806 23.4023 21.4806C24.286 21.4806 25.0023 22.1969 25.0023 23.0806Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8031 25.7739C18.8031 26.6576 18.0868 27.3739 17.2031 27.3739C16.3195 27.3739 15.6031 26.6576 15.6031 25.7739C15.6031 24.8903 16.3195 24.1739 17.2031 24.1739C18.0868 24.1739 18.8031 24.8903 18.8031 25.7739Z",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconGray);
export default __webpack_public_path__ + "static/media/listIconGray.0baac0eaf981a21e96c4b447b45aaad4.svg";
export { ForwardRef as ReactComponent };